import React from 'react';
import { useNavigate } from 'react-router-dom';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import Button from '@mui/material/Button';
import get from 'lodash/get';
import './styles.css';

const PaymentFailedHeader = (props) => {
  const navigate = useNavigate();
  let firstError = '';
  const errors = get(props, 'errors');
  if (errors) {
    firstError = Object.values(errors)[0] || '';
  }

  return (
    <>
      <div className="payment-failed-wrapper">
        <div className="payment-error-icon-container">
          <WarningRoundedIcon className="payment-error-icon" />
        </div>
        <div className="payment-failed-errors">
          <div className="payment-error-one">{firstError}</div>
          <div className="payment-error-two">ERROR</div>
          <div className="return-to-invoice">
            <Button
              className="return-to-invoice-button"
              variant="outlined"
              onClick={() => navigate(-1)}
            >
              Return To Invoice
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentFailedHeader;
